import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild, ViewChildren } from '@angular/core';
import { isString, merge } from 'lodash-es';
import { ApiResponse } from "../../../classes/api-response";
import { SnackService } from "../../../services/snack.service";
import { Box } from "../../../model/box";
import { Researcher } from "../../../model/researcher";
import { UsersService } from "../../../services/users.service";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatAutocomplete } from '@angular/material/autocomplete';
import { ContractsService } from 'src/app/services/contracts.service';
import FuzzySearch from 'fuzzy-search';

@Component({
  selector: 'aw-add-researchers-to-box',
  templateUrl: './add-researchers-to-box.component.html',
  styleUrls: ['./add-researchers-to-box.component.scss']
})
export class AddResearchersToBoxComponent implements OnInit {

  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  loadingResearchers = false;
  saving = false;
  generalError?: ApiResponse;

  selectedResearchers: Researcher[] = [];
  filteredResearchers: Researcher[] = [];
  allPossibleResearchers: Researcher[] = [];
  @Input() inputString = '';
  @ViewChild('in') inputField: ElementRef;
  @ViewChild('autocomplete') autocompleteField: MatAutocomplete;
  private fuzzySearcher: FuzzySearch<Researcher>;

  constructor(
    private snackService: SnackService,
    private usersService: UsersService,
    private contractService: ContractsService,
    @Inject(MAT_DIALOG_DATA) public injectedBox: Box,
  ) {
    this.loadingResearchers = true;
    this.usersService.getAllResearchers().subscribe(researchers => {
      if (injectedBox.researchers) {
        let ids = injectedBox.researchers.map(researcher => researcher.id);
        researchers = researchers.filter((researcher) => !ids.includes(researcher.id));
      }
      this.allPossibleResearchers = researchers;
      this.fuzzySearcher = new FuzzySearch(this.allPossibleResearchers, ["firstName", "lastName", "email"], { caseSensitive: false, sort: true });
      this.sortAlphabeticallyByLastName(this.allPossibleResearchers);
      this.filteredResearchers = researchers;
      this.loadingResearchers = false;
      if (!this._box.id) throw Error("There was a problem with the injection of the box");
      contractService.getContractByBox(this._box.id).subscribe(contractRetrieved => {
        this._box.contract = contractRetrieved;
      })
    });
  }

  showFilteredData() {
    this.filteredResearchers = this.allPossibleResearchers;
    if (isString(this.inputString)) {
      let string: string = this.inputString.trim();
      string = this.inputString.toLowerCase();
      const separatedString: string[] = string.split(' ');
      const researcherSet: Set<Researcher> = new Set<Researcher>();
      separatedString.forEach(substring => {
        const subSet = this.fuzzySearcher.search(substring);
        subSet.forEach(researcher => {
          researcherSet.add(researcher);
        });
      });
      this.filteredResearchers = Array.from(researcherSet);
    }
  }


  private sortAlphabeticallyByLastName(arr: Researcher[]) {
    arr.sort((a, b) => {
      if (a && b && a.lastName && b.lastName) {
        return a.lastName.toLowerCase().localeCompare(b.lastName.toLowerCase());
      }
      else
        return 0;
    });
  }

  onOptionClicked(researcher: Researcher) {
    if (researcher) {
      if (!this.selectedResearchers.includes(researcher)) {
        this.selectedResearchers.push(researcher);
        this.allPossibleResearchers.splice(this.allPossibleResearchers.indexOf(researcher), 1);
        this.resetInput();
      }
      else this.snackService.error("User already selected");
    }
  }

  removeChip(researcher: Researcher) {
    this.selectedResearchers.splice(this.selectedResearchers.indexOf(researcher), 1);
    this.allPossibleResearchers.push(researcher);
    this.sortAlphabeticallyByLastName(this.allPossibleResearchers);
    this.showFilteredData();
  }

  resetInput() {
    this.inputField.nativeElement.value = '';
    this.inputString = "";
    this.showFilteredData();
    this.inputField.nativeElement.blur();
    setTimeout(() => {
      this.inputField.nativeElement.focus();
    }, 0);
  }

  _box = new Box();

  @Input() set box(value: Box) {
    this._box = merge(new Box(), value);
  }

  ngOnInit(): void {
  }


  addResearchers(): void {
    this.saving = true;
    if (!this._box.contract) throw Error("Could not load contract from the backend: check your internet connection and privileges")
    this.usersService.addResearchersToBox(this.selectedResearchers, this._box.id, this._box.contract?.id)
      .subscribe(
        () => {
          this.saving = false;
          if (this.selectedResearchers)
            this.selectedResearchers.forEach((researcher: Researcher) => {
              this.injectedBox.researchers?.push(researcher);
            });
          this.snackService.success('Researchers associated!');
          this.saved.emit();
        },
        error => {
          this.saving = false;
          this.snackService.error(error.message);
          this.generalError = error;
        });
  }
}